import api from '@/modules/api'
import { mutationNames } from '@/store/storeKey'

export default {
  state: {
    pdfModuleInfo: {
      'Id': 0,
      'PageTitle': '',
      'InstagramId': '',
      'SubscriptionModuleActivation_Id': 0,
      'HeaderElements': '',
      'FooterElements': ''
    },
    pdfDocList: []
  },
  getters: {
    pdfModuleInfo: state => state.pdfModuleInfo,
    pdfDocList: state => state.pdfDocList
  },
  mutations: {
    [mutationNames.SET_PDFMODULEINFO] (state, pdfinfo) {
      state.pdfModuleInfo = pdfinfo
    },
    [mutationNames.UPDATE_PDFMODULEINFO] (state, obj) {
      Object.assign(state.pdfModuleInfo, obj)
    },
    [mutationNames.UPDATE_PDFDOCLIST] (state, obj) {
      state.pdfDocList = obj
    }
  },
  actions: {
    async getpdfModule ({ commit, getters }, SubscriptionModuleId) {
      const response = await api.AppModules.GetPDFModuleInfo(SubscriptionModuleId)
      commit(mutationNames.SET_PDFMODULEINFO, response)
    },
    updatepdfSettings ({dispatch, commit}, payload) {
      commit(mutationNames.UPDATE_PDFMODULEINFO, payload)
      dispatch('savePDFSettings', payload)
    },
    savePDFSettings ({dispatch, getters}) {
      let PdfModuleInfo = Object.assign({}, getters.pdfModuleInfo)
      console.log('savePDFSettings', PdfModuleInfo)
      return api.AppModules.SavePDFSettings(PdfModuleInfo)
    },
    updatePDFDocList ({dispatch, commit}, payload) {
      commit(mutationNames.UPDATE_PDFDOCLIST, payload)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/appModules/pdfModule.js